import React from "react";
import moment from "moment";
import { toCamelCase } from "../../../hooks/toCameCase.tsx";

interface PartnerInfoCardProps {
  partner: any;
  profileUrl: string;
  checkDate: Date;
}

const PartnerInfoCard: React.FC<PartnerInfoCardProps> = ({
  partner,
  profileUrl,
  checkDate,
}) => {
  return (
    <div style={styles.card}>
      <div style={styles.cardBody}>
        <div style={styles.header}>
          <h5 style={styles.title}>Información del Chilito</h5>
        </div>

        <div style={styles.avatarContainer}>
          <img
            src={profileUrl || "/assets/img/avatar.jpg"}
            alt="Foto de perfil"
            style={styles.avatar}
            onError={(e) => {
              e.currentTarget.src = "/assets/img/avatar.jpg";
            }}
          />
        </div>

        <div style={styles.content}>
          <h4 style={styles.name}>
            {toCamelCase(
              `${partner.person?.firstName} ${partner.person?.lastName} ${partner.person?.secondLastName}`
            )}
          </h4>

          <div style={styles.infoSection}>
            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>
                <i className="fas fa-briefcase" style={styles.infoIcon}></i>
                Puesto
              </div>
              <div style={styles.infoValue}>
                {partner.candidate?.vacancy?.position?.name || "Sin puesto"}
              </div>
            </div>

            <div style={styles.infoItem}>
              <div style={styles.infoLabel}>
                <i className="fas fa-building" style={styles.infoIcon}></i>
                Sucursal
              </div>
              <div style={styles.infoValue}>
                {partner.candidate?.branch?.name || "Sin sucursal"}
              </div>
            </div>
          </div>

          <div style={styles.dateSection}>
            <h6 style={styles.dateTitle}>
              <i className="fas fa-calendar-alt" style={styles.dateIcon}></i>
              Fecha del Chequeo
            </h6>
            <div style={styles.dateBox}>
              <i className="fas fa-info-circle" style={styles.dateInfoIcon}></i>
              <strong>Fecha:</strong>{" "}
              {moment(checkDate).format("dddd, DD [de] MMMM [de] YYYY")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  card: {
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
    overflow: "hidden",
    height: "100%",
    border: "1px solid #e5e7eb",
  },
  cardBody: {
    padding: "1.5rem",
  },
  header: {
    textAlign: "center",
    marginBottom: "1.5rem",
  },
  title: {
    margin: 0,
    fontSize: "1.125rem",
    fontWeight: 600,
    color: "#50B7C0",
  },
  avatarContainer: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "1.5rem",
  },
  avatar: {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "4px solid #f8f9fa",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  },
  content: {
    textAlign: "center",
  },
  name: {
    margin: "0 0 1.5rem 0",
    fontSize: "1.25rem",
    fontWeight: 700,
    color: "#1f2937",
  },
  infoSection: {
    marginBottom: "1.5rem",
  },
  infoItem: {
    marginBottom: "1rem",
  },
  infoLabel: {
    fontSize: "0.75rem",
    color: "#6b7280",
    marginBottom: "0.25rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
  },
  infoIcon: {
    fontSize: "0.875rem",
    color: "#50B7C0",
  },
  infoValue: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "#1f2937",
  },
  dateSection: {
    marginTop: "1.5rem",
    paddingTop: "1.5rem",
    borderTop: "1px solid #e5e7eb",
  },
  dateTitle: {
    textAlign: "center",
    marginBottom: "0.75rem",
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#374151",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
  },
  dateIcon: {
    fontSize: "0.875rem",
    color: "#50B7C0",
  },
  dateBox: {
    background: "#f0f9ff",
    border: "1px solid #bae6fd",
    borderRadius: "8px",
    padding: "0.75rem",
    fontSize: "0.875rem",
    color: "#0369a1",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  dateInfoIcon: {
    fontSize: "0.875rem",
  },
};

export default PartnerInfoCard;
